// Shop page: size-first entry, Flow (cover flow) and Grid views, the bottom
// Filter sheet, title/price search, and Reset. Loaded on collection pages only.
// Everything works off the cards already in #objects-grid (main.js merges every
// later page into it) — filtering just toggles display/order on those cards, so
// the Grid, the Flow and the product popup's Previous/Next always agree.
(function () {
  'use strict';
  var grid = document.getElementById('objects-grid');
  var shop = document.getElementById('shop');
  if (!grid || !shop) return;

  function $(id) { return document.getElementById(id); }
  var root = document.documentElement;
  var HANDLE = window.ACM_SHOP_COLLECTION_HANDLE || '';
  var ISMAIN = HANDLE === 'all';

  var ST = { size: '', price: 0, types: {}, vibe: '', q: '', order: '', i: 0, view: 'flow' };

  function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }

  // ── helpers ──────────────────────────────────────────────
  function norm(s) {
    s = (s || '').toLowerCase();
    if (s.normalize) s = s.normalize('NFD').replace(/[̀-ͯ]/g, '');
    return s.replace(/[–—\-]/g, ' ');
  }
  var SIZE_LABEL = { xxs: 'XXS', xs: 'XS', s: 'S', m: 'M', l: 'L', xl: 'XL', xxl: 'XXL', xxxl: 'XXXL' };
  var SIZE_ORDER = ['xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl', 'xxxl'];
  function sizeGroup(raw) {
    raw = (raw || '').toLowerCase();
    if (!raw) return '';
    if (SIZE_LABEL[raw]) return raw;
    if (raw === '2xl') return 'xxl';
    if (raw === '3xl') return 'xxxl';
    var head = raw.split('-')[0];
    if (SIZE_LABEL[head]) return head;
    return 'other';
  }
  function sg(card) {
    if (card._sg === undefined) card._sg = sizeGroup(card.dataset.size);
    return card._sg;
  }
  function allCards() { return Array.prototype.slice.call(grid.querySelectorAll('.object')); }
  function isAvail(card) { return card.dataset.available !== 'false'; }

  var curCode = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '';
  function money(n) {
    try {
      if (curCode) return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: curCode, maximumFractionDigits: 0 }).format(n);
    } catch (e) {}
    return String(Math.round(n));
  }

  // ── filtering ────────────────────────────────────────────
  function activeTypeKeys() { return Object.keys(ST.types).filter(function (k) { return ST.types[k]; }); }

  function matches(card) {
    var d = card.dataset;
    if (ST.size && sg(card) !== ST.size) return false;
    if (ST.price && (parseFloat(d.priceNum) || 0) > ST.price) return false;
    var tk = activeTypeKeys();
    if (tk.length && tk.indexOf(d.type) < 0) return false;
    if (ST.vibe && d.vibe !== ST.vibe) return false;
    return true;
  }

  // Title first (word starts rank above mid-word hits), then price. Never
  // descriptions or tags — only what's printed on the card.
  function searchRank(card, q) {
    var title = norm(card.dataset.title);
    var words = title.split(/\s+/);
    for (var i = 0; i < words.length; i++) if (words[i].indexOf(q) === 0) return 0;
    if (title.indexOf(q) > -1) return 1;
    var pd = norm(card.dataset.price).replace(/\s/g, '');
    var pn = String(Math.round(parseFloat(card.dataset.priceNum) || 0));
    var qc = q.replace(/\s/g, '');
    if (qc && (pd.indexOf(qc) > -1 || pn.indexOf(qc) > -1)) return 1;
    return -1;
  }

  function applyFilters() {
    var q = norm(ST.q.trim());
    allCards().forEach(function (card) {
      var ok = matches(card);
      var rank = 0;
      if (ok && q) { rank = searchRank(card, q); if (rank < 0) ok = false; }
      card.style.display = ok ? '' : 'none';
      // available first, sold after; search rank leads within each
      card.style.order = String((isAvail(card) ? 0 : 4) + rank);
    });
  }

  function visible() {
    var cards = allCards();
    var out = [];
    cards.forEach(function (c, idx) { if (c.style.display !== 'none') out.push({ c: c, idx: idx, o: parseInt(c.style.order || '0', 10) }); });
    out.sort(function (a, b) { return a.o - b.o || a.idx - b.idx; });
    return out.map(function (x) { return x.c; });
  }
  window.acmVisibleCards = visible;

  // ── order ────────────────────────────────────────────────
  function applyOrder() {
    if (ST.order !== 'asc' && ST.order !== 'desc') return;
    var cards = allCards();
    cards.sort(function (a, b) {
      var pa = parseFloat(a.dataset.priceNum) || 0, pb = parseFloat(b.dataset.priceNum) || 0;
      return ST.order === 'asc' ? pa - pb : pb - pa;
    });
    cards.forEach(function (c) { grid.appendChild(c); });
  }

  // ── size screen ──────────────────────────────────────────
  function buildSizeChips() {
    var box = $('size-chips');
    if (!box) return;
    var counts = {};
    var total = 0;
    allCards().forEach(function (c) {
      if (!isAvail(c)) return;
      total++;
      var g = sg(c);
      if (g && g !== 'other') counts[g] = (counts[g] || 0) + 1;
    });
    var h = '';
    SIZE_ORDER.forEach(function (g) {
      if (!counts[g]) return;
      h += '<button type="button" class="pill size-chip" data-s="' + g + '">' + SIZE_LABEL[g] + ' <span class="size-count">' + counts[g] + '</span></button>';
    });
    box.innerHTML = h;
    var t = $('size-total');
    if (t) t.textContent = total ? total : '';
  }

  function closeSizeScreen() { root.classList.remove('acm-need-size'); }

  function chooseSize(g) {
    ST.size = g;
    lsSet('acm_size', g);
    ST.i = 0;
    closeSizeScreen();
    render();
  }

  // ── rendering ────────────────────────────────────────────
  var flowEls = {};
  var flowCache = {};
  var flowList = [];

  function stageMetrics() {
    var st = $('flow-stage');
    var W = st ? st.clientWidth : 320;
    var phone = window.matchMedia && window.matchMedia('(max-width: 760px)').matches;
    // Phones: the front cover is almost the full width so a thumb always lands on the photo.
    var front = phone ? Math.max(220, W - 20) : Math.max(150, Math.min(W * 0.6, 360));
    return { W: W, front: front, phone: phone };
  }

  function flowShell() {
    var v = $('flow-view');
    if (v.getAttribute('data-ready')) return;
    v.setAttribute('data-ready', '1');
    v.innerHTML =
      '<div class="flow-stage" id="flow-stage">' +
        '<button type="button" class="flow-edge flow-edge-l" id="flow-edge-l" aria-label="Previous piece">&#8249;</button>' +
        '<button type="button" class="flow-edge flow-edge-r" id="flow-edge-r" aria-label="Next piece">&#8250;</button>' +
      '</div>' +
      '<div class="flow-meta"><div class="flow-title" id="flow-title"></div><div class="flow-price" id="flow-price"></div></div>' +
      '<input type="range" class="flow-slider" id="flow-slider" min="0" max="0" value="0" aria-label="Move along the row">' +
      '<div class="flow-count" id="flow-count"></div>' +
      '<button type="button" class="flow-open" id="flow-open">View piece</button>';
    $('flow-edge-l').addEventListener('click', function (e) { e.stopPropagation(); flowStep(-1); });
    $('flow-edge-r').addEventListener('click', function (e) { e.stopPropagation(); flowStep(1); });
    $('flow-open').addEventListener('click', function () { var c = flowList[ST.i]; if (c && window.openViewer) window.openViewer(c.dataset.handle); });

    $('flow-slider').addEventListener('input', function () { ST.i = parseInt(this.value, 10) || 0; flowUpdate(); });

    var st = $('flow-view');
    var x0 = null, moved = false;
    st.addEventListener('pointerdown', function (e) { if (e.target.closest('input,.flow-open,.flow-edge')) return; x0 = e.clientX; moved = false; });
    st.addEventListener('pointermove', function (e) { if (x0 !== null && Math.abs(e.clientX - x0) > 8) moved = true; });
    st.addEventListener('pointercancel', function () { x0 = null; });
    st.addEventListener('pointerup', function (e) {
      if (x0 === null) return;
      var dx = e.clientX - x0;
      x0 = null;
      if (Math.abs(dx) > 30) { moved = true; flowStep(dx < 0 ? 1 : -1); }
    });
    st.addEventListener('click', function (e) {
      if (moved) { e.stopPropagation(); e.preventDefault(); moved = false; }
    }, true);
    window.addEventListener('resize', function () { if (ST.view === 'flow') flowUpdate(); });
  }

  function flowStep(dir) {
    var n = flowList.length;
    if (!n) return;
    var next = ST.i + dir;
    if (next < 0 || next > n - 1) return;
    ST.i = next;
    flowUpdate();
  }

  function coverFor(k) {
    var card = flowList[k];
    var el = flowEls[k];
    if (el) return el;
    el = document.createElement('div');
    el.className = 'flow-cover';
    var img = document.createElement('img');
    img.alt = card.dataset.title || '';
    img.draggable = false;
    img.src = card.dataset.img || '';
    el.appendChild(img);
    if (!isAvail(card)) {
      var b = document.createElement('div');
      b.className = 'flow-sold';
      b.textContent = 'SOLD';
      el.appendChild(b);
    }
    el.addEventListener('click', function () {
      if (k === ST.i) { if (window.openViewer) window.openViewer(card.dataset.handle); }
      else { ST.i = k; flowUpdate(); }
    });
    $('flow-stage').appendChild(el);
    flowEls[k] = el;
    return el;
  }

  var FACT = [0, 0.78, 1.08, 1.3];
  var SCALE = [1, 0.62, 0.5, 0.42];
  var OPAC = [1, 0.85, 0.55, 0.28];

  function flowUpdate() {
    var n = flowList.length;
    if (!n) return;
    if (ST.i > n - 1) ST.i = n - 1;
    if (ST.i < 0) ST.i = 0;
    var m = stageMetrics();
    var st = $('flow-stage');
    st.style.height = Math.round(m.front + 36) + 'px';
    var keep = {};
    for (var o = -3; o <= 3; o++) {
      var k = ST.i + o;
      if (k < 0 || k > n - 1) continue;
      keep[k] = true;
      var el = coverFor(k);
      var a = Math.abs(o), sgn = o < 0 ? -1 : 1;
      el.style.width = m.front + 'px';
      el.style.height = m.front + 'px';
      el.style.left = Math.round((m.W - m.front) / 2) + 'px';
      el.style.top = (a === 0 ? 0 : 18) + 'px';
      el.style.zIndex = String(10 - a);
      el.style.opacity = String(OPAC[a]);
      var fact = m.phone ? [0, 0.9, 1.4, 1.8][a] : FACT[a];
      el.style.transform = a === 0
        ? 'none'
        : 'perspective(900px) translateX(' + Math.round(sgn * fact * m.front) + 'px) rotateY(' + (-sgn * 32) + 'deg) scale(' + SCALE[a] + ')';
      el.classList.toggle('is-front', a === 0);
    }
    Object.keys(flowEls).forEach(function (key) {
      if (!keep[key]) { flowEls[key].remove(); delete flowEls[key]; }
    });
    // warm the next few photos so swiping stays instant
    for (var p = -4; p <= 5; p++) {
      var pk = ST.i + p;
      if (pk < 0 || pk > n - 1) continue;
      var src = flowList[pk].dataset.img;
      if (src && !flowCache[src]) { var im = new Image(); im.src = src; flowCache[src] = 1; }
    }
    var card = flowList[ST.i];
    $('flow-edge-l').style.visibility = ST.i > 0 ? '' : 'hidden';
    $('flow-edge-r').style.visibility = ST.i < n - 1 ? '' : 'hidden';
    var eh = Math.round(m.front);
    ['flow-edge-l', 'flow-edge-r'].forEach(function (id) {
      var b = $(id); b.style.height = eh + 'px'; b.style.width = Math.round(m.front * 0.25) + 'px';
    });
    $('flow-edge-l').style.left = Math.round((m.W - m.front) / 2) + 'px';
    $('flow-edge-r').style.left = Math.round((m.W + m.front) / 2 - m.front * 0.25) + 'px';
    $('flow-title').textContent = card.dataset.title || '';
    $('flow-price').textContent = isAvail(card) ? (card.dataset.price || '') : 'Sold';
    var sl = $('flow-slider');
    sl.max = String(Math.max(0, n - 1));
    sl.value = String(ST.i);
    $('flow-count').textContent = (ST.i + 1) + ' / ' + n;
  }

  function pillBar() {
    var sp = $('size-pill');
    if (sp) {
      if (ST.size && SIZE_LABEL[ST.size]) { sp.hidden = false; sp.textContent = 'Size ' + SIZE_LABEL[ST.size] + ' ×'; }
      else sp.hidden = true;
    }
    var other = (ST.price ? 1 : 0) + activeTypeKeys().length + (ST.vibe ? 1 : 0) + (ST.q ? 1 : 0);
    var fb = $('filter-btn');
    if (fb) { fb.textContent = other ? 'Filter · ' + other : 'Filter'; fb.classList.toggle('pill-on', !!other); }
    ['flow', 'grid'].forEach(function (v) {
      var b = $('view-' + v);
      if (b) b.classList.toggle('pill-on', ST.view === v);
    });
  }

  function render(keepHandle) {
    var handle = keepHandle || null;
    applyFilters();
    var list = visible();
    var availN = list.filter(isAvail).length;
    var cnt = $('shop-count');
    if (cnt) cnt.textContent = availN + ' piece' + (availN === 1 ? '' : 's');
    var fshow = $('f-show');
    if (fshow) fshow.textContent = 'Show ' + availN;

    root.setAttribute('data-acm-view', ST.view);
    pillBar();

    var empty = $('shop-empty');
    if (empty) empty.hidden = list.length > 0;

    if (handle) {
      var idx = list.findIndex(function (c) { return c.dataset.handle === handle; });
      if (idx > -1) ST.i = idx;
    }
    if (ST.i > list.length - 1) ST.i = Math.max(0, list.length - 1);

    if (ST.view === 'flow') {
      flowShell();
      Object.keys(flowEls).forEach(function (k) { flowEls[k].remove(); });
      flowEls = {};
      flowList = list;
      $('flow-view').style.display = list.length ? '' : 'none';
      if (list.length) flowUpdate();
    }
    if (sheetOpen) fillSheet();
  }

  // ── filter sheet ─────────────────────────────────────────
  var sheetOpen = false;

  function chip(label, on, key, val) {
    return '<button type="button" class="pill fchip' + (on ? ' pill-on' : '') + '" data-k="' + key + '" data-v="' + String(val).replace(/"/g, '&quot;') + '">' + label + '</button>';
  }

  function niceCeil(x) {
    if (x <= 0) return 0;
    var m = Math.pow(10, Math.floor(Math.log(x) / Math.LN10));
    var step = m / 2;
    return Math.round(x / step) * step;
  }

  function fillSheet() {
    var avail = allCards().filter(isAvail);
    // size
    var counts = {};
    avail.forEach(function (c) { var g = sg(c); if (g && g !== 'other') counts[g] = (counts[g] || 0) + 1; });
    var h = chip('All', !ST.size, 'size', '');
    SIZE_ORDER.forEach(function (g) { if (counts[g]) h += chip(SIZE_LABEL[g], ST.size === g, 'size', g); });
    $('f-size').innerHTML = h;
    // price — thresholds taken from the real price spread, in whatever
    // currency the visitor is seeing, so the labels always read naturally
    var prices = avail.map(function (c) { return parseFloat(c.dataset.priceNum) || 0; }).filter(function (n) { return n > 0; }).sort(function (a, b) { return a - b; });
    var th = [];
    if (prices.length) {
      [0.25, 0.5, 0.75].forEach(function (q) {
        var t = niceCeil(prices[Math.min(prices.length - 1, Math.floor(prices.length * q))]);
        if (t > 0 && th.indexOf(t) < 0) th.push(t);
      });
    }
    h = chip('All', !ST.price, 'price', 0);
    th.forEach(function (t) { h += chip('Under ' + money(t), ST.price === t, 'price', t); });
    $('f-price').innerHTML = h;
    // type
    var types = {};
    allCards().forEach(function (c) { var t = c.dataset.type; if (t) types[t] = c.dataset.typeLabel || t; });
    var keys = Object.keys(types).sort(function (a, b) { return types[a].localeCompare(types[b]); });
    var tg = $('f-type-group');
    if (tg) tg.style.display = keys.length > 1 ? '' : 'none';
    h = chip('All', activeTypeKeys().length === 0, 'type', '');
    keys.forEach(function (k) { h += chip(types[k], !!ST.types[k], 'type', k); });
    $('f-type').innerHTML = h;
    // vibe (only when the shop uses the vibe-light / vibe-dark tags)
    var fv = $('f-vibe');
    if (fv) fv.innerHTML = chip('All', !ST.vibe, 'vibe', '') + chip('Light', ST.vibe === 'light', 'vibe', 'light') + chip('Dark', ST.vibe === 'dark', 'vibe', 'dark');
    // order
    $('f-order').innerHTML = chip('Shuffle', ST.order === 'shuffle', 'order', 'shuffle') + chip('Price low–high', ST.order === 'asc', 'order', 'asc') + chip('Price high–low', ST.order === 'desc', 'order', 'desc');
  }

  function openSheet() {
    sheetOpen = true;
    fillSheet();
    $('fsheet').classList.add('on');
    $('fdim').classList.add('on');
    document.body.classList.add('sheet-open');
  }
  function closeSheet() {
    sheetOpen = false;
    $('fsheet').classList.remove('on');
    $('fdim').classList.remove('on');
    document.body.classList.remove('sheet-open');
  }

  function resetAll() {
    ST.size = ''; ST.price = 0; ST.types = {}; ST.vibe = ''; ST.q = ''; ST.order = ''; ST.i = 0;
    lsSet('acm_size', '');
    var si = $('shop-search-input');
    if (si) si.value = '';
    render();
  }

  $('f-reset').addEventListener('click', resetAll);
  $('empty-reset').addEventListener('click', resetAll);
  $('filter-btn').addEventListener('click', function () { sheetOpen ? closeSheet() : openSheet(); });
  $('fdim').addEventListener('click', closeSheet);
  $('f-show').addEventListener('click', function () { closeSheet(); });
  $('size-pill').addEventListener('click', function () { ST.size = ''; lsSet('acm_size', ''); ST.i = 0; render(); });

  $('fsheet').addEventListener('click', function (e) {
    var b = e.target.closest('.fchip');
    if (!b) return;
    var k = b.getAttribute('data-k'), v = b.getAttribute('data-v');
    if (k === 'size') { ST.size = v; lsSet('acm_size', v); ST.i = 0; }
    else if (k === 'price') { ST.price = parseFloat(v) || 0; ST.i = 0; }
    else if (k === 'type') {
      if (!v) ST.types = {}; else ST.types[v] = !ST.types[v];
      ST.i = 0;
    }
    else if (k === 'vibe') { ST.vibe = v; ST.i = 0; }
    else if (k === 'order') {
      ST.order = v;
      if (v === 'shuffle') { if (window.shuffleObjectsGrid) window.shuffleObjectsGrid(); }
      else applyOrder();
      ST.i = 0;
    }
    render();
  });

  // ── view switch ──────────────────────────────────────────
  function setView(v) {
    ST.view = v;
    lsSet('acm_view', v);
    var cur = flowList[ST.i] ? flowList[ST.i].dataset.handle : null;
    render(cur);
  }
  $('view-flow').addEventListener('click', function () { setView('flow'); });
  $('view-grid').addEventListener('click', function () { setView('grid'); });

  // ── size screen wiring ───────────────────────────────────
  $('size-chips').addEventListener('click', function (e) {
    var b = e.target.closest('.size-chip');
    if (b) chooseSize(b.getAttribute('data-s'));
  });
  $('size-skip').addEventListener('click', function () {
    lsSet('acm_size', '');
    ST.size = '';
    closeSizeScreen();
    render();
  });

  // ── search ───────────────────────────────────────────────
  var searchBox = $('shop-search');
  var searchInput = $('shop-search-input');
  function openSearch() {
    searchBox.classList.add('open');
    closeSizeScreen();
    setTimeout(function () { searchInput.focus(); }, 30);
  }
  function closeSearch() { searchBox.classList.remove('open'); }
  var navSearch = $('nav-search');
  if (navSearch) navSearch.addEventListener('click', function () { searchBox.classList.contains('open') ? closeSearch() : openSearch(); });
  searchInput.addEventListener('input', function () { ST.q = searchInput.value; ST.i = 0; render(); });
  // Enter / Search key hides the phone keyboard so the Flow gets its full height back
  searchInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); searchInput.blur(); } });
  function resettleFlow() { if (ST.view === 'flow' && flowList.length) { window.scrollTo(0, 0); flowUpdate(); } }
  searchInput.addEventListener('blur', function () { setTimeout(resettleFlow, 250); });
  if (window.visualViewport) window.visualViewport.addEventListener('resize', function () { if (ST.view === 'flow') flowUpdate(); });
  if (location.hash === '#search') openSearch();

  // ── keyboard ─────────────────────────────────────────────
  document.addEventListener('keydown', function (e) {
    var viewerOpen = $('object-viewer') && $('object-viewer').classList.contains('open');
    if (e.key === 'Escape') {
      if (sheetOpen) { closeSheet(); return; }
      if (searchBox.classList.contains('open') && !viewerOpen) closeSearch();
      return;
    }
    if (viewerOpen || sheetOpen || ST.view !== 'flow') return;
    var tag = (document.activeElement && document.activeElement.tagName) || '';
    if (tag === 'INPUT' && document.activeElement.type === 'text') return;
    if (root.classList.contains('acm-need-size')) return;
    if (e.key === 'ArrowRight') flowStep(1);
    if (e.key === 'ArrowLeft') flowStep(-1);
  });

  // ── closing the popup lands the flow on the piece you were viewing ──
  var _closeViewer = window.closeViewer;
  if (typeof _closeViewer === 'function') {
    window.closeViewer = function (fromPop) {
      var h = window._viewerHandle;
      _closeViewer(fromPop);
      if (h) { ST.i = Math.max(0, visible().findIndex(function (c) { return c.dataset.handle === h; })); if (ST.view === 'flow') { flowUpdate(); } }
    };
  }

  // ── boot ─────────────────────────────────────────────────
  var saved = lsGet('acm_size');
  if (ISMAIN && saved) ST.size = saved;
  var sv = lsGet('acm_view');
  ST.view = sv === 'grid' ? 'grid' : 'flow';

  buildSizeChips();
  render();

  document.addEventListener('acm:merged', function () {
    var cur = flowList[ST.i] ? flowList[ST.i].dataset.handle : null;
    buildSizeChips();
    if (ST.order === 'asc' || ST.order === 'desc') applyOrder();
    render(cur);
  });
})();
